import { attach } from 'effector'
import { useStore } from 'effector-react'
import { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'

import { getFromStorage } from '../../lib/storage'
import { CarData } from '../car/types'
import { $cityFromLocalStorage, fetchCitiesFx, fetchWidgetCarsFx, userSelectedCity } from './model'
import { CarsWidgetProps } from './types'

let citiesRequested = false

export const useCarsForWidget = (props: CarsWidgetProps) => {
  const [cars, setCars] = useState<CarData[] | null>(null)
  const [fetching, setFetching] = useState(true)
  const theme = useTheme()
  const [totalCount, setTotalCount] = useState(0)

  const [pagesLoaded, setPagesLoaded] = useState(1)

  const cityFromLocalStorage = useStore($cityFromLocalStorage)
  const [error, setError] = useState<string | null>(null)
  const loadNextPage = () => setPagesLoaded(pagesLoaded + 1)
  const [minPrice, setMinPrice] = useState<number | null>(null)

  const fetchingCities = useStore(fetchCitiesFx.pending)

  useEffect(() => {
    if (!citiesRequested) {
      const storedCities = getFromStorage('citySelectselectedCities')

      if (!storedCities || storedCities?.length === 0) {
        userSelectedCity([])
      } else {
        fetchCitiesFx(props.getCitiesUrl).then()
      }
    }

    citiesRequested = true
  }, [props.getCitiesUrl, fetchingCities])

  useEffect(() => {
    if (cityFromLocalStorage) {
      attach({ effect: fetchWidgetCarsFx })({
        baseUrl: props.getUrl,
        filter: props.filterValues,
        permanentFilterValues: null,
        sorting: null,
        creditFilter: null,
        carViewSettings: props.carViewSettings,
        appTheme: theme,
        city: cityFromLocalStorage,
        pagesLoaded: props.showAsSlider ? 1 : pagesLoaded,
        pageLength: props.showAsSlider ? props.carsInSlider : props.pageLength || 1,
        firstLoadPage: true,
        filterWithDefaultValue: false,
        filterDeclaration: null
      })
        .then((data) => {
          const cars = props.smartContractInstalled ? data?.cars?.map(omitAllPricesExceptBase) : data?.cars
          setCars(cars)
          setMinPrice(data?.minFilteredPrice || 0)
          setTotalCount(data?.total_count)
        })
        .catch(setError)
        .finally(() => setFetching(false))
    }
  }, [cityFromLocalStorage, pagesLoaded])

  return {
    totalCount,
    cars,
    fetching,
    loadNextPage,
    pagesLoaded,
    error,
    minPrice
  }
}

const omitAllPricesExceptBase = (car: CarData): CarData => {
  return {
    ...car,
    priceWithDiscounts: car.price
  }
}
